import axios from 'axios';
var general = {
    methods: {
        getInterfaceText(key, args) {
            if (this.interfaceTexts != undefined && this.interfaceTexts.length > 0) {
                let obj = this.interfaceTexts.find(o => o.Key === key);
                if (obj != undefined) {
                    return obj.Value.format(args);
                }
            }
            return key + '-[label not found]';
        },

        validateLoqateAddress(street, postalcode, city, email, phone, state, loqateKey, abortWhenCountryIsInvalid, _callbackKeep, _callbackUpdate, _callbackEnd) {
            var url = '/' + window.culture + '/validate-address';
            axios({
                method: "post",
                url: url,
                data: { Street: street, PostalCode: postalcode, City: city, Email: email, Phone: phone, State: state, LoqateKey: loqateKey, AbortWhenCountryIsInvalid: abortWhenCountryIsInvalid }
            })
                .then(function (res) {
                    if (_callbackEnd) {
                        _callbackEnd(res.data);
                    }
                    if (res.data != null) {
                        if (res.data.Result == false) {
                            //$('#validationAddress').hide();
                            //$('#validationCountry').hide();
                            //$('#validationEmail').hide();
                            //$('#validationPhone').hide();
                            //$('#btnAddressSearchUpdate').hide();
                            //$('#btnAddressCancel').hide();
                            //$('#btnAddressSearchKeep').show();
                            //$('#btnAddressSearchKeep').off('click');
                            //$('#btnAddressSearchUpdate').off('click');

                            //$('#btnAddressSearchKeep').on('click', function () {
                            //    if (_callbackKeep) {
                            //        _callbackKeep();
                            //    }
                            //});

                            //for (var i = 0; i < res.data.Validations.length; i++) {
                            //    if (res.data.Validations[i].Type == 'address' && res.data.Validations[i].Address.CountryIso2 == window.countryCode.toUpperCase()) {
                            //        var address = res.data.Validations[i].Address;
                            //        $('#street_filled').text(street);
                            //        $('#postalcode_filled').text(postalcode);
                            //        $('#city_filled').text(city);
                            //        $('#state_filled').text(state);
                            //        $('#street_suggestion').text(address.Line1);
                            //        $('#postalcode_suggestion').text(address.PostalCode);
                            //        $('#city_suggestion').text(address.City);
                            //        $('#state_suggestion').text(address.ProvinceCode);

                            //        $('#validationAddress').show();
                            //        $('#btnAddressSearchUpdate').show();

                            //        $('#btnAddressSearchUpdate').on('click', function () {

                            //            if (_callbackUpdate) {
                            //                _callbackUpdate(address);
                            //            }
                            //        });
                            //    }

                            //    if (res.data.Validations[i].Type == 'address' && res.data.Validations[i].Address.CountryIso2 != window.countryCode.toUpperCase()) {
                            //        $('#validationCountry').show();
                            //        $('#btnAddressCancel').show();
                            //        $('#btnAddressSearchKeep').hide();
                            //    }

                            //    if (res.data.Validations[i].Type == 'email') {
                            //        $('#email_filled').text(email);
                            //        $('#validationEmail').show();
                            //        if (res.data.Validations.length == 1) {
                            //            //only show this button when address is correct and only email address is incorrect
                            //            $('#btnAddressCancel').show();
                            //        }
                            //    }
                            //    else if (res.data.Validations[i].Type == 'phone') {
                            //        $('#phone_filled').text(phone);
                            //        $('#validationPhone').show();
                            //        $('#btnAddressCancel').show();
                            //        $('#btnAddressSearchKeep').hide();
                            //    }

                            //    $('#AddressValidateFailedModal').modal('show');

                            //}
                            //return;
                        }
                    }
                    if (_callbackKeep) {
                        _callbackKeep();
                    }
                });

        },

        accountLogin(email, password, expanded, success, failed) {
            if (expanded == undefined) {
                expanded = false;
            }

            var url = '/' + window.culture + '/account/login';
            axios({
                method: "post",
                url: url,
                data: { email: email, password: password, expanded: expanded },
                //data: { email: email, password: password, token: token, expanded: expanded },
            })
                .then(function (res) {
                    if (res.data.error != undefined && res.data.error.length == 0) {
                        var expireDate = new Date();
                        expireDate.setDate(expireDate.getDate() + 7);

                        if (success) {
                            success(res.data.result);
                        }
                        //$cookies.put('accountToken', res.data.result.Token, {
                        //    path: '/' + culture,
                        //    'expires': expireDate,
                        //    secure: true,
                        //    samesite: 'none'
                        //});

                        //push email to klaviyo
                        //if (that.getConsent().indexOf('statistics') > -1 && that.getConsent().indexOf('marketing') > -1) {
                        //    klaviyo.push(['identify', {
                        //        // Change the line below to dynamically print the user's email.
                        //        '$email': email
                        //    }]);
                            //var _learnq = _learnq || [];
                            //_learnq.push(['identify', { '$email': email }]);
                        //}

                        //track GA
                        window.trackEventGlobalAndLocal('Log in', 'Click', 'Checkout');

                        //GA4
                        window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'login' });
                    } else {
                        if (failed) {
                            failed(res.data);
                        }
                        //if (res.data.result.Token == null) {
                        //    $cookies.remove('accountToken', { path: '/' + culture });
                        //}
                    }
                });
        },

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },

        getConsent() {
            var value = this.getCookie('cookieControlPrefs');
            return (value === undefined) ? "" : value;
        },

        GAclientId() {
            var ga_clientId;
            try {
                if (window.ga.getAll()[0].get('clientId') != undefined) {
                    ga_clientId = window.ga.getAll()[0].get('clientId');
                }
            } catch (e) {
                //do nothing
            }
            return ga_clientId;
        },
        decimalToCurrencyFormat(amount) {
            return new Intl.NumberFormat(window.cultureFull, {
                style: 'currency',
                currency: window.currencyCode
            }).format(amount);
        },
        makeSafeForTracking(value) {
            if (!value) {
                return value;
            }

            return value
                .replace(/'/g, '')
                .replace(/"/g, '')
                .trimEnd();
        },
    },
}

export default general;